const IMG_PATH = "/img";
const USERS = `${IMG_PATH}/users`;

// 95 x 92 pixels 20kb
export const user = `${USERS}/userMale.png`;
